import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { combineReducers } from '@ngrx/store';
import { SystemInfoModule } from './ducks/system-info/system-info.module';
import { SystemInfoEffects } from './ducks/system-info/store';
import { WindowModule } from './ducks/window/window.module';
import { panelReducer } from 'app/modules/shared-area/ducks/panel/store/panel.reducer';
import { IPanelState } from 'app/modules/shared-area/ducks/panel/store/panel.state';
import { userProfileReducer } from 'app/modules/shared-area/ducks/user-profile/store/user-profile.reducer';
import { UserProfileEffects } from 'app/modules/shared-area/ducks/user-profile/store/user-profile.effects';
import { UserProfileState } from 'app/modules/shared-area/ducks/user-profile/store/user-profile.state';

import { userReducer } from 'app/modules/shared-area/ducks/user/store';
import { IUserState } from 'app/modules/shared-area/ducks/user/store/user.state';
import { sachverhaltReducer } from 'app/modules/shared-area/entry-components/sachverhalt/store/sachverhalt.reducer';
import { SachverhaltEffects } from 'app/modules/shared-area/entry-components/sachverhalt/store/sachverhalt.effects';
import { ISachverhaltState } from 'app/modules/shared-area/entry-components/sachverhalt/store/sachverhalt.state';
import { SachverhaltCreateModule } from './entry-components/sachverhalt/sachverhalt-create/sachverhalt-create.module';
import { IStartPageInfoState, systemInfoReducer } from './ducks/system-info/store';
import { UserEffects } from './ducks/user/store';
import { IMerkmalState } from './ducks/merkmal/store/merkmal.state';
import { merkmalReducer } from './ducks/merkmal/store/merkmal.reducer';
import { MerkmalEffects } from './ducks/merkmal/store/merkmal.effects';

export interface ISharedAreaState {
  userProfile: UserProfileState;
  panels: IPanelState;
  user: IUserState;
  merkmale: IMerkmalState;
  sachverhalt: ISachverhaltState;
  systemInfo: IStartPageInfoState;
}

export const sharedReducers = combineReducers<ISharedAreaState>({
  userProfile: userProfileReducer,
  panels: panelReducer,
  user: userReducer,
  merkmale: merkmalReducer,
  sachverhalt: sachverhaltReducer,
  systemInfo: systemInfoReducer,
});

@NgModule({
  imports: [
    SachverhaltCreateModule,
    SystemInfoModule,
    WindowModule,
    EffectsModule.forFeature([
      SachverhaltEffects,
      UserProfileEffects,
      MerkmalEffects,
      UserEffects,
      SystemInfoEffects,
    ]),
  ],
})
export class SharedAreaModule {}
